/**
 * DATA PIPELINE
 * ----------------------------------------------------------------------------
 * Fetches the five JSON "stored data" files in parallel, then runs each
 * through its Morphism schema to produce render-ready view-models.
 * The renderer never touches raw JSON — it only ever reads the view-models,
 * so swapping the data files re-skin the whole site with no code changes.
 */
import {
  transform,
  profileSchema,
  experienceSchema,
  workSchema,
  projectsSchema,
  academicSchema,
  awardsSchema,
} from './schemas.js';

import profileRaw from './data/profile.json';
import experienceRaw from './data/experience.json';
import workRaw from './data/work.json';
import projectsRaw from './data/projects.json';
import academicRaw from './data/academic.json';
import awardsRaw from './data/awards.json';

/** Run every statically imported JSON file through Morphism. */
export async function loadData() {
  return {
    profile: transform(profileSchema, profileRaw),
    experience: transform(experienceSchema, experienceRaw),
    work: transform(workSchema, workRaw),
    projects: transform(projectsSchema, projectsRaw),
    academic: transform(academicSchema, academicRaw),
    awards: transform(awardsSchema, awardsRaw),
  };
}
